import { Chip, Stack, Typography } from '@mui/material'
import React from 'react'

import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'

export const MonitorSearchListResult: React.FC<{
  name: string
  tags: string[] | null
}> = ({ name, tags }) => {
  return (
    <>
      <TruncatedTextWithTooltip
        sx={{ minWidth: 180, py: 0.5, mr: 2 }}
        tooltipProps={{ title: name }}
        variant="body2"
      >
        {name}
      </TruncatedTextWithTooltip>
      {tags && tags !== null && (
        <Stack
          direction="row"
          sx={{
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: 'end',
            py: 0.5,
            width: '100%'
          }}
        >
          {tags.map((tag) => {
            const [category, value] = tag.split(':', 2)

            if (!value) return <Chip key={tag} label={tag} size="small" />

            return (
              <Chip
                key={tag}
                label={
                  <Stack direction="row" spacing={1}>
                    <Typography
                      sx={{ fontWeight: 'bold' }}
                      variant="secondaryCaption"
                    >
                      {category}:
                    </Typography>
                    <Typography variant="secondaryCaption">{value}</Typography>
                  </Stack>
                }
              />
            )
          })}
        </Stack>
      )}
    </>
  )
}
